import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase Web SDK configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID, // Optional, if you use Analytics
};

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  console.error("Firebase initialization error:", error);
  // You might want to throw the error or handle it in a way that displays a message to the user
  // For now, this will prevent the app from crashing if config is missing, but auth will fail.
  // A better approach for a production app would be to have a fallback or clear error state.
  app = initializeApp({}); // Initialize with empty config to prevent further crashes, though auth won't work
}


// Get Auth instance
// We get auth instance conditionally, only if app was initialized successfully with a project ID.
// Firebase getAuth() will throw an error if initializeApp did not receive a valid config with a projectId.
let auth;
if (app.options && app.options.projectId) {
  auth = getAuth(app);
} else {
  console.error("Firebase Auth could not be initialized because Firebase app initialization failed or projectId is missing.");
  // To prevent crashes, we can create a mock auth object or leave it undefined.
  // For now, leaving it potentially undefined. Components using it should check.
  // A more robust solution would involve an error state in AuthContext.
}

export { auth, app }; // Export auth for signInWithCustomToken and app if needed elsewhere 